import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("App ErrorBoundary caught:", error, info);
  }
  reset = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.reload();
  };
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-5" style={{ background: "linear-gradient(160deg, #0B132B, #1c2a4d)" }} data-testid="error-boundary">
          <div className="tk-card p-6 max-w-md w-full text-center">
            <div className="text-2xl mb-2">⚠️</div>
            <h2 className="text-lg font-display font-semibold mb-1">Bir şeyler ters gitti</h2>
            <p className="text-sm mb-4" style={{ color: "hsl(var(--text-2))" }}>
              Sayfa beklenmedik bir hata verdi. Yenilemeyi dene; sorun devam ederse İsmet'e haber ver.
            </p>
            <pre className="text-[10px] text-left rounded-md p-3 mb-4 overflow-auto max-h-32" style={{ backgroundColor: "hsl(var(--surface-2))", color: "#9aa3b5" }}>
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button onClick={this.reset} className="tk-btn" data-testid="error-boundary-reload">
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
